/**
 * 对FetchOption的功能进行简单扩展
 */
export default class Option implements RequestInit {
  body?: BodyInit | null;

  credentials?: RequestCredentials = "include";

  headers: HeadersInit = {};

  /**
   * 返回原始的请求返回值，不进行额外的处理
   */
  originResponse?: boolean;

  constructor(
    public method?: string,
    option?: RequestInit,
  ) {
    if (option) {
      Object.assign(this, option);
    }
  }

  /**
   * 设置Body
   */
  setBody = (body) => {
    if (Object.prototype.toString.apply(body) === "[object FormData]") {
      this.body = body;
      // 如果已经设置过，拿掉设置的值，否则boundary会有问题
      this.removeHeader("Content-Type");
    } else if (typeof body === "object") {
      this.body = JSON.stringify(body);
      this.addHeader("Content-Type", "application/json");
    } else {
      this.body = body;
    }
  };

  /**
   * 设置一个header头
   */
  addHeader = (key, value) => {
    if (value && String(value) !== "null") {
      this.headers[key] = value;
    }
  };

  /**
   * 删除一个header头
   */
  removeHeader = (key) => {
    delete this.headers[key];
  };

  /**
   * 获取值
   */
  valueOf = () => {
    const {
      setBody,
      addHeader,
      removeHeader,
      valueOf,
      ...rest
    } = this;

    return rest;
  };
}
